import * as React from 'react';
import classNames from 'classnames';
import { Button, Typography, Space } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { Trans } from 'react-i18next';
import styles from '../EntityManager.module.scss';
const { Text } = Typography;
function EntityDelete(props) {
    return (React.createElement("div", { className: styles.deleteContainer },
        React.createElement("div", { className: styles.deleteContent },
            React.createElement("div", { className: styles.deleteQuestion }, props.question),
            props.error && React.createElement(Text, { type: "danger" }, props.error),
            React.createElement(Space, { className: styles.deleteActions, size: "large" },
                React.createElement(Button, { className: classNames('big', styles.operationCancelButton), onClick: () => props.onCancel(), disabled: props.loading },
                    React.createElement(Trans, { i18nKey: "cancel" })),
                React.createElement(Button, { disabled: props.loading, className: classNames('big', styles.operationContinueButton), type: "primary", danger: true, onClick: () => props.onContinue() }, props.loading ? React.createElement(LoadingOutlined, null) : React.createElement(Trans, { i18nKey: "deleteSubmit" }))))));
}
export default EntityDelete;
